export interface MachineCategory {
  id: string;
  label: string;
  icon: string;
  pattern: RegExp;
}

export const MACHINE_CATEGORIES: MachineCategory[] = [
  { id: "print", label: "เครื่องพิมพ์ (P03–P11, S01–S02)", icon: "🖨️", pattern: /^(P\d{2}|S\d{2})$/ },
  { id: "digital", label: "เครื่องพิมพ์ Digital (Di-01, Di-02)", icon: "🖨️", pattern: /^Di-\d{2}$/ },
  { id: "die", label: "เครื่องปั้มมีด/ฟอยล์ (D01–D12, DC, DR, Digital DC)", icon: "🔪", pattern: /^(D\d{2}|DC-?\d{2}|DR-?\d{2}|Digital DC-?\d{2})$/ },
  { id: "slice", label: "เครื่องสลิด (Slice/Auto)", icon: "✂️", pattern: /^(Slice|Auto)$/ },
  { id: "coat", label: "เครื่องเคลือบ (Coat)", icon: "🛡️", pattern: /^Coat/i },
  { id: "cup", label: "เครื่องแก้ว (MC01–MC02)", icon: "🥤", pattern: /^MC\d{2}$/ },
  { id: "other", label: "อื่น ๆ", icon: "⚙️", pattern: /.*/ },
];

export function categorizeMachine(machine: string): MachineCategory {
  for (const cat of MACHINE_CATEGORIES) {
    if (cat.pattern.test(machine)) return cat;
  }
  // Unreachable — "other" is catch-all.
  return MACHINE_CATEGORIES[MACHINE_CATEGORIES.length - 1];
}

export function groupMachinesByCategory<T extends { machine: string }>(
  machines: T[],
): { category: MachineCategory; items: T[] }[] {
  const buckets = new Map<string, { category: MachineCategory; items: T[] }>();
  for (const m of machines) {
    const cat = categorizeMachine(m.machine);
    const existing = buckets.get(cat.id);
    if (existing) {
      buckets.set(cat.id, { ...existing, items: [...existing.items, m] });
    } else {
      buckets.set(cat.id, { category: cat, items: [m] });
    }
  }
  // Preserve declared category order
  return MACHINE_CATEGORIES.filter((c) => buckets.has(c.id)).map(
    (c) => buckets.get(c.id)!,
  );
}
